<template>
    <div id="InformationImage" class="w3 w90-mb">
        <h1 class="h1 center">圖片下載專區</h1>
        <ul id="information-image-list">
            <li v-for="(item, index) in imageList" :key="'image-' + index">
                <div class="img-wrap">
                    <img :src="item.imgUrl" :alt="item.title + 'image'" />
                    <i
                        tabindex="0"
                        role="button"
                        class="icon-preview"
                        @click="toggleLightBox(index)"
                        @keypress.enter="toggleLightBox(index)"
                        @keydown.esc="toggleLightBox()"
                    ></i>
                </div>
                <div class="title-wrap">
                    <h3 class="h3">{{ item.title.ch }}</h3>
                    <h4 class="f16 f12-mb">{{ item.title.en }}</h4>
                    <a
                        :href="item.imgUrl"
                        :download="item.title.ch"
                        class="link"
                    >
                        <i class="icon-image"></i><span>下載圖片</span>
                    </a>
                </div>
            </li>
        </ul>
        <div
            class="light-box"
            :class="{ activated: displayLightBox }"
            @mousewheel.stop="preventD"
            @touchmove.stop="preventD"
        >
            <div class="mask" @click="toggleLightBox()"></div>
            <main>
                <div class="close-wrap">
                    <i
                        class="icon-close"
                        tabindex="0"
                        role="button"
                        @click="toggleLightBox()"
                        @keypress.enter="toggleLightBox()"
                    ></i>
                </div>
                <img
                    :src="imageList[activeIndex].imgUrl"
                    :alt="imageList[activeIndex].title.ch + 'image'"
                />
            </main>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue-demi'
export default {
    name: 'InformationImage',
    setup() {
        const activeIndex = ref(0)
        const displayLightBox = ref(false)
        function toggleLightBox(index) {
            if (index !== undefined) {
                activeIndex.value = index
                displayLightBox.value = false
            }
            displayLightBox.value = !displayLightBox.value
        }
        function preventD(e) {
            e.stopPropagation()
            e.preventDefault()
        }
        const imageList = [
            {
                title: {
                    ch: '海洋廢棄物循環標章',
                    en: 'English Title of the Image',
                },
                imgUrl: '../img/badge.png',
            },
        ]

        return {
            imageList,
            activeIndex,
            toggleLightBox,
            displayLightBox,
            preventD,
        }
    },
}
</script>
<style lang="scss" scoped>
#InformationImage {
    @media screen and (min-width: 768px) {
        margin-bottom: 80px;
    }
    @media screen and (max-width: 767px) {
        margin-bottom: 50px;
    }
}
#information-image-list {
    display: grid;
    li {
        box-shadow: $shadow1;
        .img-wrap {
            position: relative;
            background-color: $grayF;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            i.icon-preview {
                position: absolute;
                z-index: 30;
                right: 15px;
                bottom: 15px;
                color: $white;
                font-size: 20px;
                cursor: pointer;
            }
            &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(
                    to top,
                    rgba($black, 0.5),
                    transparent
                );
            }
        }
        .title-wrap {
            padding: 10px 15px;
            h3 {
                color: $gray2;
                font-weight: 500;
                @media screen and (min-width: 768px) {
                    line-height: 1.2em;
                }
                @media screen and (max-width: 767px) {
                    line-height: 1.5em;
                }
            }
            h4 {
                line-height: 1.2em;
                padding-bottom: 1em;
            }
        }
    }

    @media screen and (min-width: 768px) {
        grid-template: auto / repeat(3, 1fr);
        grid-gap: 20px;
        .img-wrap {
            height: 250px;
        }
    }
    @media screen and (max-width: 767px) {
        grid-template: auto / 1fr;
        grid-gap: 20px;
        .img-wrap {
            height: 200px;
        }
    }
}
.light-box {
    display: none;
    z-index: 2000;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    align-items: center;
    justify-content: center;

    &.activated {
        display: flex;
    }
    main {
        position: relative;
        top: -5vh;
        box-sizing: border-box;
        background-color: $white;

        .close-wrap {
            padding: 10px 0 20px;
            display: block;
            text-align: right;
        }
        i.icon-close {
            cursor: pointer;
            transform: rotate(-45deg);
            &::after,
            & {
                display: inline-block;
                width: 30px;
                height: 3px;
                border-radius: 2px;
                background-color: $gray6;
            }
            &::after {
                content: '';
                position: relative;
                top: -12px;
                transform: rotate(90deg);
            }
        }
        img {
            display: block;
            width: 100%;
            max-height: 70vh;
            object-fit: contain;
        }
    }
    .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba($black, 0.5);
    }

    @media screen and (min-width: 768px) {
        main {
            width: 70%;
            padding: 30px;
        }
    }
    @media screen and (max-width: 767px) {
        main {
            width: 90%;
            padding: 20px;
        }
    }
}
</style>
